var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5C3.5 7.72876 3.5 5.84315 4.67157 4.67157C5.84315 3.5 7.72876 3.5 11.5 3.5H16.5C20.2712 3.5 22.1569 3.5 23.3284 4.67157C24.5 5.84315 24.5 7.72876 24.5 11.5V16.5C24.5 20.2712 24.5 22.1569 23.3284 23.3284C22.1569 24.5 20.2712 24.5 16.5 24.5H11.5C7.72876 24.5 5.84315 24.5 4.67157 23.3284C3.5 22.1569 3.5 20.2712 3.5 16.5V11.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 8.16663L13.9998 19.8333M19.8332 14L8.1665 14",
    stroke: "#FF8C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.53328ac0a4711a1713dbb0a9fb42fb30.svg";
export { ForwardRef as ReactComponent };